import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get, set } from '../utils/lodash';

import { withStyles } from '@mui/styles';

import ArrowRightOutlinedIcon from '@mui/icons-material/ArrowRightOutlined';

import Node from './Node';
import LoaderNew from './LoaderNew';
import CommonStyles from './CommonStyles';
import ComponentWrapper from './ComponentWrapper';
import TrplCheckbox from './TrplControls/TrplCheckbox';

const styles = {
  loaderContainer: {
    display: 'flex',
    padding: '20px 0',
    justifyContent: 'center',
  },
  idColumn: {
    width: '22px',
    paddingLeft: '30px',
    flexShrink: '0',
    color: '#4c4c4c',
  },
  parentLine: {
    top: 15,
    width: 1,
    zIndex: 1,
    bottom: 0,
    marginTop: 17,
    marginBottom: 15,
    position: 'absolute',
    backgroundColor: '#DBD6E6',
  },
  switcherContainer: {
    zIndex: 1,
    width: 24,
    height: 24,
    flexShrink: 0,
  },
  nodesContainer: {
    width: '100%',
    position: 'relative',
    boxSizing: 'border-box',
  },
  rowCheckbox: {
    '& .MuiSvgIcon-root': {
      fontSize: 15,
    },
    '& .Mui-checked': {
      color: '#222029',
    },
  },
  rowCheckboxContainer: {
    height: 48,
    display: 'flex',
    paddingLeft: 20,
    position: 'absolute',
  },
  rowCheckboxContainerHovered: {
    background: '#F1EEF5',
  },
  ...CommonStyles,
};

class OntologyTreeNodes extends Component {
  hasChildren = (member) => member && member.children && Object.keys(member.children).length;

  addClass = (rowCheckboxClassName) => {
    const { classes } = this.props;
    const rowCheckbox = document.querySelector(`.${rowCheckboxClassName}`);

    if (rowCheckbox) rowCheckbox.classList.add(classes.rowCheckboxContainerHovered);
  };

  removeClass = (rowCheckboxClassName) => {
    const { classes } = this.props;
    const rowCheckbox = document.querySelector(`.${rowCheckboxClassName}`);

    if (rowCheckbox) rowCheckbox.classList.remove(classes.rowCheckboxContainerHovered);
  };

  render() {
    const {
      level,
      styles,
      classes,
      members,
      openLevel,
      parentMember,
      previousPath,
      hideCheckboxes,
      dashboardIdsByAccConcept,
    } = this.props;

    return (
      <div>
        {members && Object.keys(members).map((nodeId, index) => {
          const member = members[nodeId];
          const node = member;

          const rowCheckboxClassName = `node-container-${level}-${nodeId}`;

          const hasChildrenFlag = this.hasChildren(member);

          const path = [...previousPath];
          if (level !== 0) path.push('children', nodeId); //find out how used, not work now

          return (
            <div className={`${level === 0 ? classes.relative : ''} ${classes.alignCenter}`} key={`${index}-${nodeId}`}>
              <div
                onMouseEnter={() => this.addClass(rowCheckboxClassName)}
                onMouseLeave={() => this.removeClass(rowCheckboxClassName)}
                className={`${rowCheckboxClassName} ${classes.rowCheckboxContainer}`}
                style={{
                  right: `${level * 15}px`,
                  left: `${level === 0 ? '-30px' : `-${level * 30}px`}`,
                  display: `${hideCheckboxes || (level !== 0 && !parentMember.isOpened) ? 'none' : 'flex'}`,
                }}
              >
                <TrplCheckbox className={classes.rowCheckbox} />
              </div>

              <div
                className={classes.nodesContainer}
                style={{
                  display: `${level !== 0 && !parentMember.isOpened ? 'none' : 'flex'}`,
                }}
              >
                {hasChildrenFlag && member.isOpened ? (
                  <div
                    className={classes.parentLine}
                    style={{
                      ...(styles ? styles.parentLine : {}),
                      left: `${32 * (level + 1) + (level === 0 ? 5 : 0)}px`,
                    }}
                  />
                ) : null}

                <div style={{ width: '100%' }}>
                  <div
                    className={classes.alignCenter}
                    onMouseEnter={() => this.addClass(rowCheckboxClassName)}
                    onMouseLeave={() => this.removeClass(rowCheckboxClassName)}
                    style={{ minHeight: '34px', flexShrink: '0', ...(styles ? styles.row : {}) }}
                  >
                    <div className={classes.idColumn}>
                      {dashboardIdsByAccConcept[nodeId] && dashboardIdsByAccConcept[nodeId]}
                    </div>

                    <div
                      className={classes.switcherContainer}
                      style={{
                        paddingLeft: `${26 * (level + 1)}px`,
                        ...(styles ? styles.switcher : {}),
                      }}
                    >
                      {hasChildrenFlag ? (
                        <ArrowRightOutlinedIcon
                          className={classes.pointer}
                          onClick={() => openLevel(path)}
                          style={{
                            transform: `${hasChildrenFlag && member.isOpened ? 'rotate(90deg)' : ''}`,
                          }}
                        />
                      ) : null}
                    </div>

                    <div style={{ width: 162, flexShrink: 0, paddingLeft: `${15 * (level + 1)}px` }}>
                      <Node
                        isLink
                        size="sm"
                        node={node}
                        nodeId={node.id}
                        nodes={members}
                        style={{
                          alignSelf: 'center',
                        }}
                      />
                    </div>

                    {this.props.children ? React.cloneElement(this.props.children, { node }) : null}
                  </div>

                  {hasChildrenFlag ? (
                    <OntologyTreeNodes
                      styles={styles}
                      level={level + 1}
                      classes={classes}
                      previousPath={path}
                      openLevel={openLevel}
                      parentMember={member}
                      members={member.children}
                      hideCheckboxes={hideCheckboxes}
                      dashboardIdsByAccConcept={dashboardIdsByAccConcept}
                    >
                      {this.props.children ? React.cloneElement(this.props.children, { node }) : null}
                    </OntologyTreeNodes>
                  ) : null}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

class OnthologyTree extends ComponentWrapper {
  state = {
    data: {},
    loaded: false,
  };

  collectSubsData = (nodes, nodeTsubsData, data, path) => {
    if (!nodeTsubsData) nodeTsubsData = [];
    nodeTsubsData.forEach((nodeId) => {
      const node = nodes[nodeId];

      set(data, [...path, nodeId], { ...node, isOpened: true });

      if (!nodes || !nodes[nodeId] || (nodes[nodeId] && !nodes[nodeId].box)) {
        console.log(`not found node ${nodeId} data in nodes for forming tree`);
        return;
      }
      const newNodeSubsData = get(nodes, [nodeId, 'box', 't_subs']);

      if (nodeTsubsData) this.collectSubsData(nodes, newNodeSubsData, data, [...path, nodeId, 'children']);
    });
  };

  componentDidMount() {
    if (!this.props.data && !this.props.nodes && this.props.ancestorId) {
      const { setup, ancestorId } = this.props; //for single ancestorId, won't work with array

      const reqData = {
        nesting: 2,
        api_key: setup.id,
        filter: {
          ancestor: ancestorId,
          do_individuals: false,
        },
      };

      const data = {};

      this.postWithData({
        url: `/pnkqry3`,
        data: reqData,
        cb: (req) => {
          const dataPath = ['nodes', ancestorId, 'box', 't_subs'];

          let ancestorTSubs;
          if (req.nodes[ancestorId].box && req.nodes[ancestorId].box.t_subs) {
            ancestorTSubs = get(req, dataPath);
          } else {
            ancestorTSubs = [];
          }

          const nodesData = {};

          ancestorTSubs.forEach((nodeId) => {
            const node = { ...req.nodes[nodeId] };
            nodesData[nodeId] = node;
          });

          const ancestorNode = req.nodes[ancestorId];

          data[ancestorId] = {
            children: {},
            isOpened: true,
            ...ancestorNode,
          };
          let tSubs = ancestorNode.box.t_subs || [];

          this.collectSubsData(req.nodes, tSubs, data, [ancestorId, 'children']);

          this.setState({ data, loaded: true });
        },
      });
    } else if (!this.props.data && this.props.nodes) {
      const { ancestorIds, nodes } = this.props;
      const data = {};

      if (ancestorIds && ancestorIds.length) {
        ancestorIds.forEach((ancestor) => {
          const dataPath = [ancestor, 'box', 't_subs'];

          let ancestorTSubs;
          if (nodes[ancestor].box && nodes[ancestor].box.t_subs) {
            ancestorTSubs = get(nodes, dataPath);
          } else {
            ancestorTSubs = [];
          }

          const nodesData = {};

          ancestorTSubs.forEach((nodeId) => {
            const node = { ...nodes[nodeId] };
            nodesData[nodeId] = node;
          });

          const ancestorNode = nodes[ancestor];
          data[ancestor] = {
            children: {},
            isOpened: true,
            ...ancestorNode,
          };
          let tSubs = ancestorNode.box.t_subs || [];
          this.collectSubsData(nodes, tSubs, data, [ancestor, 'children']);

          this.setState({ data, loaded: true });
        });
      } else {
        this.setState({ loaded: true });
      }
    } else {
      this.setState({ data: this.props.data, loaded: true });
    }
  }

  openLevel = (path) => {
    const { data } = this.state;

    const isOpenedPath = [...path, 'isOpened'];
    const isOpened = get(data, isOpenedPath);

    const updatedData = set(data, isOpenedPath, !isOpened);

    this.setState({ data: updatedData });
  };

  render() {
    const {
      styles,
      classes,
      ancestorIds,
      rowChildren,
      hideCheckboxes,
      dashboardIdsByAccConcept,
    } = this.props;

    const { loaded } = this.state;

    const data = this.props.data || this.state.data;

    return (
      <div>
        {loaded ? (
          <OntologyTreeNodes
            level={0}
            members={data}
            styles={styles}
            classes={classes}
            rowChildren={rowChildren}
            openLevel={this.openLevel}
            previousPath={[ancestorIds]} //find out how used, not work now
            hideCheckboxes={hideCheckboxes}
            dashboardIdsByAccConcept={dashboardIdsByAccConcept}
          >
            {this.props.children ? React.cloneElement(this.props.children, { id: ancestorIds }) : null}
          </OntologyTreeNodes>
        ) : (
          <div className={classes.loaderContainer}>
            <LoaderNew />
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => ({
  setup: state.meta.setup,
}))(withStyles(styles)(OnthologyTree));
